import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/Waterstream_logo.png";

export default function NavBar() {
  return (
    <nav className="bg-white shadow p-4 flex justify-between items-center">
      <div className="max-w-screen-xl mx-auto flex justify-center items-center space-x-6">
        {/* <img src={logo} alt="Waterstream.ai Logo" className="h-9 w-9" />
        <span className="text-2xl font-bold text-blue-400">Waterstream AI</span> */}
        <Link to="/" className="flex items-center space-x-0">
          <img src={logo} alt="Waterstream.ai Logo" className="h-9 w-9" />
          <span className="text-xl font-bold text-blue-400">
            Waterstream AI
          </span>
        </Link>
        <div className="space-x-4">
          <Link
            to="/insight"
            className="hover:underline font-bold text-blue-400"
          >
            Insight
          </Link>
          <Link
            to="/hugmyself"
            className="hover:underline font-bold text-blue-400"
          >
            HugMySelf
          </Link>
          <Link
            to="/rewrite-it"
            className="hover:underline font-bold text-blue-400"
          >
            RewriteIt
          </Link>
          <Link
            to="/contact"
            className="hover:underline font-bold text-blue-400"
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
}
